<script setup lang="ts">
import { sanitizeUrl } from '@scalar/helpers/url/is-safe-url'
import { ScalarIconLink } from '@scalar/icons'
import { computed } from 'vue'

const { url } = defineProps<{
  name: string
  url: string
}>()

/**
 * The link URL comes from the `x-scalar-links` extension of the OpenAPI document, which is
 * untrusted input, so a protocol like `javascript:` would execute script on click. Fall back to
 * the plain text label in that case.
 */
const safeUrl = computed(() => sanitizeUrl(url))
</script>

<template>
  <div
    class="group narrow:border-r-0 narrow:first:ml-0 flex items-center border-r first:ml-auto last:border-r-0">
    <a
      v-if="safeUrl"
      class="text-c-1 hover:bg-b-2 narrow:border mr-2 flex min-h-7 min-w-7 items-center rounded-lg px-2 py-1 no-underline group-last:mr-0"
      :href="safeUrl"
      rel="noopener noreferrer"
      target="_blank">
      <ScalarIconLink
        class="size-3 text-current"
        weight="bold" />
      <span class="ml-1 empty:hidden">{{ name }}</span>
    </a>
    <template v-else>
      <ScalarIconLink
        class="size-3 text-current"
        weight="bold" />
      <span class="ml-1 empty:hidden">{{ name }}</span>
    </template>
  </div>
</template>
